import { create } from "zustand";
import { devtools } from "zustand/middleware";

type TState = {
  isCreditCardFormShow: boolean;
  isTopBannerShow: boolean;
  appLang: string;
  isMobileMenuShow: boolean;
  hideIntercom: boolean;
  applyPromoCodeFromParmOnBuyPlan: boolean;
};

type TActions = {
  setIsCreditCardFormShow: (isCreditCard: boolean) => void;
  setIsTopBannerShow: (isShow: boolean) => void;
  setAppLang: (lang: string) => void;
  setIsMobileMenuShow: (curr: boolean) => void;
  setHideIntercom: (state: boolean) => void;
  setApplyPromoCodeFromParmOnBuyPlan: (curr: boolean) => void;
};

type TAppState = TState & TActions;

const useAppStore = create<TAppState>()(
  devtools((set) => ({
    isCreditCardFormShow: false,
    isTopBannerShow: false,
    appLang: "en",
    isMobileMenuShow: false,
    hideIntercom: false,
    applyPromoCodeFromParmOnBuyPlan: false,
    //
    setIsCreditCardFormShow: (isCreditCard: boolean) =>
      set({ isCreditCardFormShow: isCreditCard }),
    setIsTopBannerShow: (isShow: boolean) => set({ isTopBannerShow: isShow }),
    setAppLang: (lang) => set({ appLang: lang }),
    setHideIntercom: (state) => set({ hideIntercom: state }),
    setIsMobileMenuShow: (state) => set({ isMobileMenuShow: state }),
    setApplyPromoCodeFromParmOnBuyPlan: (state) =>
      set({ applyPromoCodeFromParmOnBuyPlan: state }),
  })),
);

export default useAppStore;
